import tool from '@/utils/tool.js'

const TokenKey = process.env.VUE_APP_HEAD_AUTH_KEY || 'authorization'
let token = ''
let local = tool.localStorage
export function getToken() {
    if (!token) { token = local.get(TokenKey) }
    return token
}
export function isTokenChange() {
    return token && token !== local.get(TokenKey)
}
export function setToken(t) {
    token = t
    return local.set(TokenKey, t)
}

export function removeToken() {
    token = ''
    return local.del(TokenKey)
}

export default {
    getToken,
    isTokenChange,
    setToken,
    removeToken
}
